import React, { ReactNode, Fragment } from 'react';
import { Container } from '../shared/Container';
import { ConsumerModel } from '../../models';
import { Header } from '../features/Header';

interface BaseLayoutProps {
    children?: ReactNode;
		consumer: ConsumerModel;
}

export function BaseLayout({ children, consumer }: BaseLayoutProps) {
    return (
        <Fragment>
					{consumer.status ? (
						<Header/>
					): null}
            <main id="content" role="main" className="surplus-calculator">
                <Container>{children}</Container>
            </main>
        </Fragment>
    );
}
